"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
export default function AboutPreview() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
          {}
          <div ref={textRef} className={`flex flex-col gap-4 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${textVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-foreground leading-tight">
              Your Trusted Home Renovation &amp; Construction Experts
            </h2>
            <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
              Showtime Construction LLC is your go-to partner for high-quality
              residential and commercial renovations in Jersey and Pennsylvania.
              Our team specializes in kitchen and bathroom remodeling, flooring
              installation, electrical, plumbing, painting, and more. With years
              of experience and a commitment to excellence, we turn your vision
              into reality.
            </p>
          </div>

          {}
          <div ref={imageRef} className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${imageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <Card className="overflow-hidden shadow-medium hover:shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
              <img src="https://showtimeconstructionllc.com/wp-content/uploads/2026/01/kitchen_renovation_before.webp" alt="Kitchen renovation showcase" className="w-full h-auto object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:scale-[1.01]" />
            </Card>
          </div>
        </div>
      </div>
    </section>;
}